import { Text } from 'components/blueprint';

export const MessageMetaWrapper = ({ children, ...rest }) => (
  <Text as="div" variant="body2" lineHeight={1.33} {...rest}>
    {children}
  </Text>
);
